<script>
  import { fade } from "svelte/transition";
  import Redirect from "../../components/backDashboard.svelte";
  import { user } from "../../firebase";
  import { format } from "date-fns";
  import { conversion, lang } from "../../store/store";

  let convert = (k) => {
    if (isNaN(k)) {
      return undefined;
    }
    let output = "";
    let hrs = k / 60;
    if (hrs <= 0) {
      hrs = Math.ceil(hrs);
    } else {
      hrs = Math.floor(hrs);
    }

    if (hrs != 0) {
      output = hrs + " " + $conversion[$lang].landing.stats.stat2.hour;
    }
    let minutes = Math.abs(k) - Math.abs(hrs) * 60;
    if (minutes != 0) {
      if (hrs != 0) {
        output =
          output +
          " et " +
          minutes +
          " " +
          $conversion[$lang].landing.stats.stat2.minutes;
      } else {
        output =
          output +
          minutes +
          " " +
          $conversion[$lang].landing.stats.stat2.minutes;
      }
    }
    if (minutes == 0 && hrs == 0) {
      output = "0 " + $conversion[$lang].landing.stats.stat2.minutes;
    }
    return output;
  };

  function handleDate(a) {
    if (($lang = "fr")) {
      let date = format(
        new Date(parseInt(a?.seconds * 1000 || a)),
        "h:mm aaa M/d/uuuu "
      );
      return date;
    } else {
      let date = format(
        new Date(parseInt(a?.seconds * 1000 || a)),
        "h:mm aaa d/M/uuuu "
      );
      return date;
    }
  }
  let temp;
  let userCharges = [];
  $user.doc.subscribe((v) => {
    if (v.transactions) {
      temp = Object.entries(v.transactions);
      userCharges = JSON.parse(JSON.stringify(temp));
      userCharges.sort(
        (a, b) =>
          (b[1].charge?.date?.seconds * 1000 || b[1].charge.date) -
          (a[1].charge?.date?.seconds * 1000 || a[1].charge.date)
      );
      console.log(userCharges);
    }
  });
  console.log("/////////////////////////////////////");
  console.log(userCharges);

  let title = $conversion[$lang].transaction.title;
</script>

<div
  in:fade={{ duration: 300, delay: 300 }}
  out:fade={{ duration: 300, delay: 0 }}
  class="contentWrapper"
>
  <Redirect bind:title />
  <div class="container">
    <div class="content-ctn">
      <div class="wrapper">
        <div class="content-txt content-padding bold">
          {$conversion[$lang].transaction.menu[1]}
        </div>
        <div class="content-txt content-padding bold">
          {$conversion[$lang].transaction.menu[2]}
        </div>
        <div class="content-txt content-padding bold">
          {$conversion[$lang].transaction.menu[3]}
        </div>
        <div class="content-txt content-padding bold">
          {$conversion[$lang].transaction.menu[4]}
        </div>
        <div class="content-txt content-padding bold">
          {$conversion[$lang].transaction.menu[5]}
        </div>
      </div>
      {#each userCharges as [id, charge], i}
        {#if charge.charge.status}
          <div class="wrapper">
            <div class="content-txt" class:active={i % 2 == 0}>
              {handleDate(charge.charge.date)}
            </div>

            <div class="content-txt small " class:active={i % 2 == 0}>
              {#if charge.charge.type == "debit"}
                {$conversion[$lang].transaction.transactiontype.purchase}{charge
                  .charge.name}
                Package (
                {convert(charge.charge.hrs)})
              {:else if charge.charge.type == "adjust"}
                {$conversion[$lang].transaction.transactiontype
                  .adjustment}{charge.charge.name}
                ({convert(
                  parseFloat(charge.charge.hrs) - charge.charge.adjustedHrs
                )})
              {:else}
                {$conversion[$lang].transaction.transactiontype.deducted}{charge
                  .charge.name}
                ( -{convert(charge.charge.hrs)})
              {/if}
            </div>

            <div class="content-txt " class:active={i % 2 == 0}>
              {convert(
                parseFloat(charge.charge.hrs) - charge.charge.adjustedHrs
              ) || convert(parseFloat(charge.charge.hrs))}
            </div>
            <div class="content-txt " class:active={i % 2 == 0}>
              {convert(charge.currentHrs)}
            </div>
            <a
              href="/TaskItemDetails/{charge.charge.id}"
              class="content-txt "
              class:active={i % 2 == 0}>{charge.charge.id}</a
            >
          </div>
        {/if}
      {/each}
    </div>
  </div>
</div>

<style>
  .contentWrapper {
    padding-bottom: 6rem;
    width: 95%;
    max-width: 1190px;
    position: absolute;
  }

  .content-ctn {
    display: flex;
    flex-direction: column;
    box-shadow: 0px 6px 58px rgba(196, 203, 214, 0.103611);
    border-radius: 24px;
    overflow: hidden;
  }

  .wrapper {
    display: flex;
    flex-direction: row;
  }

  .content-txt {
    font-size: 0.875em;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20%;
    background-color: white;
    padding: 0.5rem 1.5rem;
    margin: 0.1rem;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .active {
    background-color: #f4f9fd;
  }

  .container {
    background-color: white;

    border-radius: 24px;
  }

  .content-padding {
    padding: 2rem 0;
    color: white;
    background-color: var(--primaryColor);
  }

  .bold {
    font-weight: 600;
  }
  .small {
    font-size: 0.95em;
  }
</style>
